<div class="background">
    <div class="bar" [style.width.%]="progress" [style.background]="color"></div>
</div>